import Vue from 'vue'
import HereMap from '@shared/Components/HereMap'

Vue.component('GuestLayout', () => import('@builder-web/Views/Shared/Layouts/Guest'))
Vue.component('AuthLayout', () => import('@builder-web/Views/Shared/Layouts/Auth'))

Vue.component('OverviewCard', () => import('@shared/Components/OverviewCard'))
Vue.component('Button', () => import('@shared/Components/Button'))
Vue.component('Calendar', () => import('@shared/Components/Calendar'))
Vue.component('DataTable', () => import('@shared/Components/DataTable'))
Vue.component('DatePicker', () => import('@shared/Components/DatePicker'))
Vue.component('FilePreview', () => import('@shared/Components/FilePreview'))
Vue.component('TextField', () => import('@shared/Components/TextField'))
Vue.component('TimePicker', () => import('@shared/Components/TimePicker'))
Vue.component('Window', () => import('@shared/Components/Window'))
Vue.component('Accordion', () => import('@shared/Components/Accordion'))
Vue.component('ThreadItem', () => import('@shared/Components/ThreadItem'))
Vue.component('ImageInput', () => import('@shared/Components/ImageInput'))
Vue.component('FileInput', () => import('@shared/Components/FileInput'))
Vue.component('Clock', () => import('@shared/Components/Clock'))
Vue.component('Tabs', () => import('@shared/Components/NavTab/Tabs'))
Vue.component('Tab', () => import('@shared/Components/NavTab/Tab'))
Vue.component('TabPanels', () => import('@shared/Components/NavTab/TabPanels'))
Vue.component('TabPanel', () => import('@shared/Components/NavTab/TabPanel'))
Vue.component('AddressAutocomplete', () => import('@shared/Components/AddressAutocomplete'))
Vue.component('PaymentForm', () => import('@shared/Components/PaymentForm'))
Vue.component('CardForm', () => import('@shared/Components/CardForm'))
Vue.component('PinchCardForm', () => import('@shared/Components/PinchCardForm'))
Vue.component('HereMap', HereMap)

Vue.component('SmallThreadItem', () => import('@shared/Components/Chatter/SmallThreadItem'))
Vue.component('Bubblies', () => import('@shared/Components/Chatter/Bubblies'))
Vue.component('Bubbly', () => import('@shared/Components/Chatter/Bubbly'))

Vue.component('Footer', () => import('@shared/Components/Mobile/Footer'))
Vue.component('DashboardBids', () => import('@shared/Components/Mobile/DashboardBids'))
Vue.component('DashboardOrders', () => import('@shared/Components/Mobile/DashboardOrders'))
Vue.component('ConvoInbox', () => import('@shared/Components/Mobile/ConvoInbox'))
Vue.component('ConvoNormal', () => import('@shared/Components/Mobile/ConvoNormal'))
Vue.component('ConvoTrash', () => import('@shared/Components/Mobile/ConvoTrash'))
Vue.component('SupplierEntry', () => import('@shared/Components/Mobile/Suppliers'))
Vue.component('Messages', () => import('@shared/Components/Mobile/Messages'))
